import { Component, Input, Output, EventEmitter, input, model } from '@angular/core';
import { Question } from 'src/app/features/medical-record/model/question.model';
import { MatDialog } from '@angular/material/dialog';
import { AllergiesComponent } from '../allergies-dialog/allergies.component';
import { AllergyItem } from '../allergies-dialog/utils/allergies';
import _ from 'lodash';
import { Allergy } from 'src/app/features/medical-record/medical-record-page/pages/anamnesis/model/anamnesis.model';
import { FormBuilder, FormControl } from '@angular/forms';

type AllergyForComponent = {
  category: string,
  types: string[]
}
@Component({
  selector: 'cmp-selected-allergies',
  templateUrl: './selected-allergies.component.html',
  styleUrls: ['./selected-allergies.component.scss']
})
export class SelectedAllergiesComponent {

  protected formAllergiesSelected = this.formBuilder.array([]);

  panelExpanded: boolean = true;
  @Input() width: string = '809px';
  @Input() height: string = '95px';
  @Input() title: string = 'ALERGIAS DECLARADAS';

  @Input() arrayItems:  Array<{ category: string, types: string[] }> = [];
  @Input() isAddingOrEditing: string = 'adding';
  @Input() isRequired: boolean = false;
  @Input() isConditionFilled: boolean = false;

  @Output() allergiesSelected = new EventEmitter();

  allergies = model<any[]>([]);

  remove({ cat, name }: { name: string, cat: string }) {
    const currentAllergies = this.allergies()
    const newAllergies = currentAllergies.map(({ category, types }) => ({
      category,
      types: types.filter((alerType: any) => alerType !== name)
    }))
      // remover categorias que fiquem sem nenhum item
      .filter(({ types }) => types.length > 0)
    this.allergies.set(newAllergies)
    this.getAllergies();
  }

  constructor(
    private dialog: MatDialog,
    private formBuilder: FormBuilder

  ) {

  }

  ngOnInit(){
    this.allergies.set(this.arrayItems);
  }

  showTitle(category: any) {

    if (this.arrayItems.length > 0) {

      if (category.category.answer[0] !== '' && category.types.find((type: any) => type.answer[0] !== '')) {

        return category.category.answer[0];
      }
    }

    return;
  }

  filterAllergiesSelected(arrayAllergies: Array<any>) {

    const arrayFiltered: Array<any> = [];

    if (this.arrayItems.length > 0) {

      arrayAllergies.forEach(category => {

        if (category.category.answer[0] !== '') {

          arrayFiltered.push(category);
        }

      });

      return arrayFiltered;
    }

    return arrayFiltered;
  }

  filterTypesSelected(arrayQuestions: Array<Question>) {

    const arrayFiltered: Array<Question> = [];

    if (this.arrayItems.length > 0) {

      arrayQuestions.forEach(type => {

        if (type.answer[0] !== '' && type.answer[0] !== 'Outros') {

          arrayFiltered.push(type);
        }
      });

      return arrayFiltered;
    }

    return arrayFiltered;
  }

  deleteAllergy(category: any, type: any) {

    category.types.forEach((item: any) => {

      item.answer[0] === type.answer[0] ? item.answer[0] = '' : '';
    });

    !category.types.find((f: any) => f.answer[0] !== '') ? category.category.answer[0] = '' : '';
    // this.getAllergies();
  }

  executeFunction() {

    this.dialog.open(AllergiesComponent, {
      minWidth: '1192px',
      data: {
        isRequired: false,
        allergies: this.allergies()
      }
    }).afterClosed().subscribe(({ allergies, type }: {
      type: 'save' | 'cancel',
      allergies: AllergyItem[]
    }) => {
      if (type === 'save') {
        const allergiesForForm: any= _.uniqBy(allergies.filter(a => a.selected).map(allergy => {
          return {
            category: allergy.item,
            types: _.uniq(allergy.items.filter(item => item.selected).map(item => item.item))
          }
        }), (item) => item.category)

        this.allergies.set(allergiesForForm);
        this.getAllergies();
      }
    });
  }

  getAllergies() {

    this.allergies().length > 0 ? this.isAddingOrEditing = 'editing' : this.isAddingOrEditing = 'adding';
    this.allergiesSelected.emit(this.allergies());
  }

  applyDesign() {

    return { width: this.width, display: 'grid' };
  }

  applyChipsDesign() {

    return { 'min-height': this.height, width: this.width };
  }
}
